import { render, staticRenderFns } from "./CashierDashboard.vue?vue&type=template&id=19d0c356&scoped=true"
import script from "./CashierDashboard.vue?vue&type=script&lang=js"
export * from "./CashierDashboard.vue?vue&type=script&lang=js"
import style0 from "./CashierDashboard.vue?vue&type=style&index=0&id=19d0c356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0c356",
  null
  
)

export default component.exports